import React from 'react';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface IProps {
    title: string;
    value: string | number;
    icon: React.FC<SvgIconProps>;
    type?: string;
}

const Component: React.FC<IProps> = ({ title, value, icon, type }: IProps) => {
    const Icon = icon;
    return (
        <ListItem className="statistics__item">
            <ListItemIcon className="statistics__item-avatar">
                <Icon className="statistics__item-ico" />
            </ListItemIcon>
            <ListItemText
                classes={{
                    root: 'statistics__item-title-wrap',
                    primary:
                        type === 'login'
                            ? 'statistics__item-title_login'
                            : 'statistics__item-title',
                }}
                primary={`${title}:`}
            />
            <Typography className="statistics__value" variant="body1">
                {value}
            </Typography>
        </ListItem>
    );
};

const StatisticsItemComponent = React.memo(Component);

export default StatisticsItemComponent;
